// The address people write to for help; also named in the privacy policy.
export const SUPPORT_EMAIL = "support@hazumu.site";
